import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative bg-background-950 border-t border-primary-500/10">
      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12">
        <div className="py-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* 品牌 */}
          <div className="lg:col-span-1">
            <Link to="/" className="mb-6 inline-block group">
              <img
                src="/logo.png"
                alt="晋铧叙梦（山西）文化科技有限公司"
                className="h-12 w-auto object-contain transition-opacity duration-300 group-hover:opacity-90"
              />
            </Link>
            <p className="text-secondary-400 text-sm leading-relaxed mb-6">
              以AI重构地域文化数字资产<br />
              冯全普·县域AI+OPC联盟核心成员单位
            </p>
            <div className="flex gap-4">
              <a href="#" className="w-9 h-9 rounded-lg bg-background-800 flex items-center justify-center text-secondary-400 hover:text-primary-500 hover:bg-primary-500/10 transition-all duration-300 cursor-pointer">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-lg bg-background-800 flex items-center justify-center text-secondary-400 hover:text-primary-500 hover:bg-primary-500/10 transition-all duration-300 cursor-pointer">
                <i className="ri-tiktok-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-lg bg-background-800 flex items-center justify-center text-secondary-400 hover:text-primary-500 hover:bg-primary-500/10 transition-all duration-300 cursor-pointer">
                <i className="ri-video-line text-lg"></i>
              </a>
            </div>
          </div>

          {/* 关于公司 */}
          <div>
            <h4 className="text-foreground-50 font-semibold text-sm mb-5">关于公司</h4>
            <div className="grid grid-cols-2 sm:grid-cols-1 gap-x-4 gap-y-3">
              {[
                { label: '首页', path: '/' },
                { label: '关于我们', path: '/about' },
                { label: '新闻动态', path: '/news' },
              ].map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  className="text-secondary-400 text-sm hover:text-primary-500 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  {item.label}
                </Link>
              ))}
            </div>
          </div>

          {/* 核心业务 */}
          <div>
            <h4 className="text-foreground-50 font-semibold text-sm mb-5">核心业务</h4>
            <div className="grid grid-cols-2 sm:grid-cols-1 gap-x-4 gap-y-3">
              {[
                { label: '核心业务', path: '/business' },
                { label: '作品案例', path: '/case' },
                { label: '技术实力', path: '/technology' },
                { label: '文化出海', path: '/overseas' },
                { label: '产教融合', path: '/education' },
              ].map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  className="text-secondary-400 text-sm hover:text-primary-500 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  {item.label}
                </Link>
              ))}
            </div>
          </div>

          {/* 合作交流 */}
          <div>
            <h4 className="text-foreground-50 font-semibold text-sm mb-5">合作交流</h4>
            <div className="grid grid-cols-2 sm:grid-cols-1 gap-x-4 gap-y-3">
              {[
                { label: '招商合作', path: '/cooperation' },
                { label: '招贤纳士', path: '/recruit' },
                { label: '联系我们', path: '/contact' },
              ].map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  className="text-secondary-400 text-sm hover:text-primary-500 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  {item.label}
                </Link>
              ))}
            </div>
            <div className="mt-6 space-y-4 text-sm text-secondary-400">
              <div className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-map-pin-line text-secondary-500"></i>
                </div>
                <span>山西省晋中市榆次区巨燕商务广场</span>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-phone-line text-secondary-500"></i>
                </div>
                <span>业务热线：（预留填写）</span>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-mail-line text-secondary-500"></i>
                </div>
                <span>招聘邮箱：（预留填写）</span>
              </div>
            </div>
          </div>
        </div>

        <div className="py-6 border-t border-primary-500/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-secondary-500 text-xs">
            &copy; {currentYear} 晋铧叙梦（山西）文化科技有限公司 | JINHUA XUMENG (SHANXI) CULTURE TECHNOLOGY CO., LTD.
          </p>
          <div className="flex gap-6 text-xs text-secondary-500">
            <span>ICP备案：（上线后补充）</span>
            <span>公安备案：（上线后补充）</span>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 pointer-events-none select-none overflow-hidden">
        <span className="block text-[12rem] md:text-[16rem] font-heading font-bold text-primary-500/[0.02] text-center leading-none whitespace-nowrap">
          晋铧叙梦
        </span>
      </div>
    </footer>
  );
}
